export default __webpack_public_path__ + "static/media/Report-With-Baseline.c1efe739.jpg";